import { render } from "./head-component.vue?vue&type=template&id=03314c76"
const script = {}

import "./head-component.vue?vue&type=style&index=0&id=03314c76&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__